import { useDictUtil } from '../useDictUtils';

export const officeTypeDict = useDictUtil({
  options: [
    { key: 1, text: '公司' },
    { key: 2, text: '部门' },
    { key: 4, text: '堆场', routeName: 'cottonSmolderingMonitor' },
    { key: 3, text: '轧花厂', routeName: 'cottonSmolderingMonitor2' }
  ]
});
